import React, { PureComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { composeValidators } from '../../../utils/helper';
import { required } from '../../../utils/validation';
import BootstrapSuccessError from './BootstrapSuccessError';
import LKModal from '../Modal/Modal';
import VoucherDetail from './VoucherDetail';
import StoreCreditOrdersList from './StoreCreditOrdersList';
import StoreCreditOrderHistory from './StoreCreditOrderHistory';
import BlankLoader from '../../components/Common/BlankLoader';
import Pagination from 'react-js-pagination';
import {
  checkStoreCreditBal,
  clearState,
  getStoreCreditOrders,
  getStoreCreditOrderHistory,
  sendStoreCreditSMS,
} from '../../../actionCreators/myAccount';

class StoreCredit extends PureComponent {
  constructor(props) {
    super(props);
    this.onCheckVoucherSubmit = this.onCheckVoucherSubmit.bind(this);
    this.close = this.close.bind(this);
    this.storeCreditBalanceMessage =
      this.props.dataLocale.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN || '';
    this.state = {
      activePage: 1,
    };
    this.activePage = 1;
    this.handlePageChange = this.handlePageChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const { storeCreditOrders } = this.props;
    const storeCreditOrdersList = storeCreditOrders && storeCreditOrders.result;
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnLoad({
        pagename: 'check gift voucher balance',
        satellite: 'account',
        subSection1: 'check gift voucher balance',
      });
    }
    if (!storeCreditOrdersList) {
      const pageNumber = window.sessionStorage.getItem('scOrderActivePage')
        ? parseInt(window.sessionStorage.getItem('scOrderActivePage'), 10)
        : 0;
      const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
      this.activePage = pageNumber;
      this.props.getStoreCreditOrders(pager, 10);
      window.sessionStorage.removeItem('scOrderActivePage');
    }
  }
  componentWillUnmount() {
    this.close();
  }
  onCheckVoucherSubmit({ checkBalance }) {
    this.props.checkStoreCreditBal(checkBalance);
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnClick({
        linkPageName: 'check store credit balance',
        linkName: 'check store credit balance',
        giftVoucherCode: checkBalance,
        clickEvent: 'onClick',
        satellite: 'generic-int-link',
      });
    }
  }
  getOrderHistory(orderId) {
    this.props.getStoreCreditOrderHistory(orderId);
  }
  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      if (this.activePage !== pageNumber) {
        const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
        this.props.getStoreCreditOrders(pager, 10);
        this.activePage = pageNumber;
        window.sessionStorage.setItem('scOrderActivePage', pageNumber);
      }
    });
  }
  sendStoreCreditSMS(orderId) {
    this.props.sendStoreCreditSMS(orderId);
  }
  close() {
    this.props.clearState({
      storeCreditBalance: null,
      storeCreditOrderHistory: null,
      storeCreditOrderSMS: null,
    });
  }

  render() {
    const {
      currencyMark,
      dataLocale,
      loading,
      storeCreditBalance,
      userInfo,
      storeCreditOrders,
      storeCreditOrderHistory,
      storeCreditOrderSMS,
      storeCreditOrdersTotal,
    } = this.props;
    let type = '';
    if (storeCreditBalance && (storeCreditBalance.error || storeCreditBalance.errors)) {
      type = 'error';
    }
    const storeCreditOrdersList = storeCreditOrders && storeCreditOrders.result;
    const totalOrders = storeCreditOrdersTotal || 0;
    const {
      MY_ORDERS,
      HELLO,
      STORE_CREDIT_BALANCE,
      SC_CODE,
      STORE_CREDIT_ORDER_HISTORY,
      CHECK_BALANCE,
      ENTER_YOUR_STORE_CREDIT_CODE,
      SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN,
      ORDERS_PAGE,
      ERROR,
      WE_HAVE_NOT_FOUND_ANY_ORDERS,
      THE_FOLLOWING_ORDERS_RECEIVED_STORE,
      CHECK_STORE_CREDIT_BALANCE,
      WE_HAVE_SENT_STORE_CREDIT_CODE,
      PLEASE_TRY_AGAIN,
    } = dataLocale;
    return (
      <div className="display-flex flex-column">
        <Helmet title={CHECK_STORE_CREDIT_BALANCE} />
        <div className="margin-t20" style={{ color: '#6d6f71', letterSpacing: '1.3px' }}>
          <h4 className="bold">
            {HELLO}
            {userInfo && <span>, {userInfo && userInfo.firstName} !</span>}
          </h4>
          <p>{THE_FOLLOWING_ORDERS_RECEIVED_STORE}</p>
        </div>
        {Boolean(storeCreditOrderSMS && storeCreditOrderSMS.status === 200) && (
          <BootstrapSuccessError message={WE_HAVE_SENT_STORE_CREDIT_CODE} type="success" />
        )}
        {Boolean(storeCreditOrderSMS && storeCreditOrderSMS.status !== 200) && (
          <BootstrapSuccessError message={PLEASE_TRY_AGAIN} type="error" />
        )}
        <hr className="separator dashed" />
        <h2>{MY_ORDERS}</h2>
        {totalOrders > 10 && (
          <div className="layout justify-content-between center">
            <p className="uppercase" style={{ color: '#6d6f71' }}>
              {ORDERS_PAGE}: {this.state.activePage}
            </p>
            <Pagination
              activeLinkClass="active-page"
              activePage={this.state.activePage}
              itemsCountPerPage={10}
              pageRangeDisplayed={10}
              totalItemsCount={totalOrders}
              onChange={this.handlePageChange}
            />
          </div>
        )}
        {loading && !storeCreditOrdersList && <BlankLoader />}
        {storeCreditOrdersList && this.state.activePage && totalOrders > 0 && (
          <StoreCreditOrdersList
            currencyMark={currencyMark}
            dataLocale={dataLocale}
            getOrderHistory={orderId => this.getOrderHistory(orderId)}
            orders={storeCreditOrdersList}
            sendSMS={orderId => this.sendStoreCreditSMS(orderId)}
          />
        )}
        {Boolean(storeCreditOrdersList && storeCreditOrdersList.orderList.length === 0) && (
          <div className="col-md-12 alert alert-warning">{WE_HAVE_NOT_FOUND_ANY_ORDERS}</div>
        )}
        {Boolean(storeCreditOrders && storeCreditOrders.errors) && (
          <div className="col-md-12 alert alert-danger">
            <strong style={{ color: '#a94442' }}>{ERROR}! </strong>{' '}
            {SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN}
          </div>
        )}
        <hr className="separator dashed" />
        <h4>{CHECK_STORE_CREDIT_BALANCE}</h4>
        {Boolean(
          storeCreditBalance && (storeCreditBalance.error || storeCreditBalance.errors) && !loading
        ) && (
          <BootstrapSuccessError
            message={storeCreditBalance.message || this.storeCreditBalanceMessage}
            type={type}
          />
        )}
        <Form
          noValidate
          autoComplete="off"
          autoCorrect="off"
          render={({ handleSubmit }) => {
            return (
              <form className="form-SLA" onSubmit={handleSubmit}>
                <div className="form-group" style={{ width: '25%' }}>
                  <Field name="checkBalance" validate={composeValidators(required)}>
                    {({ input, meta }) => (
                      <div className={meta.touched && meta.error ? 'has-error' : ''}>
                        <label className="control-label">{ENTER_YOUR_STORE_CREDIT_CODE}*</label>
                        <input className="form-control" {...input} autoComplete="off" type="text" />
                        {meta.touched && meta.error && (
                          <div className="help-block with-errors">{meta.error}</div>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
                <div
                  className="padding-t20  padding-b20 col-sm-8 padding-l0"
                  style={{ borderTop: '1px dashed #ccc' }}
                >
                  <button
                    className="btn-submit btn btn-primary col-sm-4 uppercase"
                    disabled={loading}
                    type="submit"
                  >
                    {CHECK_BALANCE}{' '}
                  </button>
                </div>
              </form>
            );
          }}
          onSubmit={this.onCheckVoucherSubmit}
        />
        {/* store credit balance dialog */}
        <LKModal
          keyboard
          backdrop="static"
          dialogClassName="voucher-detail"
          headerTitle={STORE_CREDIT_BALANCE}
          hideHandler={this.close}
          showModal={Boolean(storeCreditBalance && storeCreditBalance.result)}
          size="large"
        >
          {Boolean(storeCreditBalance && storeCreditBalance.result) && (
            <VoucherDetail
              close={this.close}
              dataLocale={dataLocale}
              voucherCode={{ title: SC_CODE, code: storeCreditBalance.result.storeCreditCode }}
              voucherDetails={storeCreditBalance.result}
            />
          )}
        </LKModal>
        {/* store credit order history dialog */}
        <LKModal
          keyboard
          backdrop="static"
          dialogClassName="store-order-history"
          headerTitle={STORE_CREDIT_ORDER_HISTORY}
          hideHandler={this.close}
          showModal={Boolean(storeCreditOrderHistory && storeCreditOrderHistory.result)}
          size="large"
        >
          {Boolean(storeCreditOrderHistory && storeCreditOrderHistory.result) && (
            <StoreCreditOrderHistory
              currencyMark={currencyMark}
              dataLocale={dataLocale}
              orderHistory={storeCreditOrderHistory.result}
              userInfo={userInfo}
            />
          )}
        </LKModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.myAccount.loading,
  userInfo: state.common.userInfo.result,
  storeCreditBalance: state.myAccount.storeCreditBalance,
  storeCreditOrders: state.myAccount.storeCreditOrders,
  storeCreditOrderHistory: state.myAccount.storeCreditOrderHistory,
  storeCreditOrderSMS: state.myAccount.storeCreditOrderSMS,
  storeCreditOrdersTotal: state.myAccount.storeCreditOrdersTotal,
  dataLocale: state.locale,
  currencyMark: state.common.currencyMark,
});

function mapDispatchToProps(dispatch) {
  return {
    checkStoreCreditBal: value => dispatch(checkStoreCreditBal(value)),
    clearState: value => dispatch(clearState(value)),
    getStoreCreditOrders: (pageName, size) => dispatch(getStoreCreditOrders(pageName, size)),
    getStoreCreditOrderHistory: orderId => dispatch(getStoreCreditOrderHistory(orderId)),
    sendStoreCreditSMS: orderId => dispatch(sendStoreCreditSMS(orderId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreCredit);
